module.exports = "/_next/static/images/d06a472be2b25a86fd9786290e41ce53-cajita-con-cdt-nu.png.webp";